// extracted by mini-css-extract-plugin
module.exports = {"container":"_2fJW2QG","heading":"_2C6SlzZ","form":"_1mj2Jcl","date":"_1nZfAGF","announcement":"_gFNLDP3"};